import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppState, PRODUCT_FEATURE} from "../../../app.state";

 export const productsFeature = createFeatureSelector<AppState>(PRODUCT_FEATURE.stateKey);
 export const selectLoading = createSelector(
  productsFeature,
  (state: AppState) => state.product_details.isLoading
);
 /*  export const  selectResponse = createSelector(
  productsFeature,
  (state: AppState) => state.product_details.data
); */

export const selectResponse = createSelector(
  productsFeature,
  (state: AppState) => {
    console.log(state.product_details)
      if(state.product_details.data.data){
        if (state.product_details.data.data.shortText) {
          state.product_details.data.data["summaryText"] = state.product_details.data.data.shortText.split(' ').slice(0, 40).join(' ') + '...';
          state.product_details.data.data["showDescriptionSummary"] = true;
        } else {
          state.product_details.data.data["summaryText"] = '';
          state.product_details.data.data["showDescriptionSummary"] = false;
        }
      }
      return state.product_details.data;
  }
);


export const selectVariations = createSelector(
  productsFeature,
  (state: AppState) =>{
   if (state.product_details.data?.data?.variations)
       return state.product_details.data?.data?.variations;
    else return [];
  }
);
export const selectDimensions = createSelector(
  selectVariations,
  (state: any) =>{
   if (state.dimensions)
       return state.dimensions;
    else return [];
  }
);

export const selectAttributes = createSelector(
  productsFeature,
  (state: AppState) =>{
   if (state.product_details.data?.data?.productAttributes)
       return state.product_details.data?.data?.productAttributes;
    else return [];
  }
);
export const selectPriceCombinations = createSelector(
  productsFeature,
  (state: AppState) =>{
   if (state.product_details.data?.data?.priceCombinations)
       return state.product_details.data?.data?.priceCombinations;
    else return [];
  }
);
export const  selectShippings= createSelector(
  productsFeature,
  (state: AppState) => state.product_details.data.data.allowedShippingTypes
);
export const  selectShippingType= createSelector(
  productsFeature,
  (state: AppState) =>  state.product_details.shippingType
);
export const  selectAttibutes= createSelector(
  productsFeature,
  (state: AppState) =>  state.product_details.attributes
);

export const  selectError= createSelector(
  productsFeature,
  (state: AppState) =>  state.product_details?.message??""
);

export const selectCurrentKey= createSelector(
  selectVariations,
  (state: any) =>{
   if (state.currentKey)
       return state.currentKey;
    else return "";
  }
);
export const  selectQuantity= createSelector(
  productsFeature,
  (state: AppState) =>  state?.product_details?.quantity??1
);
